export default "__VITE_ASSET__DiqGkZGX__"